import React from 'react';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { Checkbox, ListItemText, MenuItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Select from 'components/common/Select';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import {
  ComponentType,
  Filters,
  ResourceFilter,
} from '@monorepo/shared/src/providers/ResourcesProvider/types';
import CharacterTile from './CharacterTile';

interface DropDownFilterProps {
  filter: Filters;
}

const DropDownFilter: React.FC<DropDownFilterProps> = ({ filter }) => {
  const classes = useStyles();
  const [{ selectedFilters }, { setSelectedFilters }] = useResources();

  const { name, values } = filter;

  const isButton = values[0].componentType === ComponentType.BUTTON;

  const selectedTags = selectedFilters.filter((item) =>
    values.find((filter) => filter.id === item.id)
  );

  const otherFiltersTags = selectedFilters.filter(
    (item) => !values.map((filterItem) => filterItem.id).includes(item.id)
  );

  const menuProps = isButton
    ? {
        classes: { list: classes.characterTiles },
      }
    : undefined;

  const isTagChecked = (tag: ResourceFilter): boolean =>
    selectedTags.findIndex((selectedTag) => selectedTag.id === tag.id) > -1;

  const renderValue = (value: any) =>
    value?.length ? value.map((item: ResourceFilter) => item.value).join(', ') : 'All';

  const handleChange = (event): void =>
    setSelectedFilters([...otherFiltersTags, ...event.target.value]);

  return (
    <div className={classes.container}>
      {name}
      <Select
        multiple
        value={selectedTags}
        MenuProps={menuProps}
        renderValue={renderValue}
        onChange={handleChange}
      >
        {values.map((tag) => (
          <MenuItem key={tag.id} value={tag as any} className={classes.menuItem}>
            {isButton ? (
              <CharacterTile size={45} character={tag} selected={isTagChecked(tag)} />
            ) : (
              <>
                <Checkbox checked={isTagChecked(tag)} />
                <ListItemText primary={tag.value} />
              </>
            )}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    width: remCalc(224),
    color: '#202020',
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '18px',
    paddingTop: '10px',
    paddingBottom: '15px',
    marginRight: '10px',
  },
  menuItem: {
    '&.Mui-selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  characterTiles: {
    display: 'grid',
    gridGap: '7px 7px',
    gridTemplateColumns: '45px 45px 45px 45px 45px',
    width: '100%',
    padding: '1rem',
    '& li': {
      padding: 0,
      '&:focus-within': {
        outline: '#248AFF auto 1px',
      },
    },
  },
}));

export default React.memo(DropDownFilter);
